import { cn } from "@/lib/utils";

/**
 * One labelled figure on its own hairline row, for the narrow card beside a
 * table (the dashboard's network card uses the same shape). The note sits
 * just before the value, muted.
 */
export function FactRow({
  id,
  label,
  value,
  note,
  className,
}: {
  id?: string;
  label: string;
  value: string;
  note?: string | null;
  className?: string;
}) {
  return (
    <div
      id={id}
      className={cn(
        "flex items-baseline justify-between gap-4 border-t border-border py-3 first:border-t-0",
        className
      )}
    >
      <div className="text-[13px] font-medium text-foreground">{label}</div>
      <div className="flex min-w-0 items-baseline gap-2">
        {note && <span className="truncate text-xs text-muted-foreground">{note}</span>}
        <span className="whitespace-nowrap text-lg font-semibold tabular-nums tracking-tight text-foreground">
          {value}
        </span>
      </div>
    </div>
  );
}
